/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reconcile_Order_RemainingInputs */

const vi_reconcile_order_remaining = /** @type {(inputs: Reconcile_Order_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn thu`)
};

/**

* @param {Reconcile_Order_RemainingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const reconcile_order_remaining = /** @type {((inputs?: Reconcile_Order_RemainingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reconcile_Order_RemainingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_reconcile_order_remaining(inputs)
});